import { mapOrder } from 'services/utilities'
import { actions } from './actions'

const initialState = {
  etiquetas: {
    data: [],
    loading: false,
    error: '',
  },
  etiqueta: {
    data: null,
    loading: false,
    error: '',
  },
}
export default function etiquetaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ETIQUETAS_LOAD_REQUESTED:
      return {
        ...state,
        etiquetas: { ...state.etiquetas, loading: true },
      }
    case actions.ETIQUETAS_LOAD_SUCCEEDED:
      return {
        ...state,
        etiquetas: { ...state.etiquetas, data: action.payload, loading: false },
      }
    case actions.ETIQUETAS_LOAD_FILED:
      return {
        ...state,
        etiquetas: { ...state.etiquetas, loading: false, error: action.error },
      }
    case actions.ETIQUETA_DELETE_REQUESTED:
      return {
        ...state,
        etiquetas: { ...state.etiquetas, loading: true, error: '' },
      }
    case actions.ETIQUETA_DELETE_SUCCEEDED:
      return {
        ...state,
        etiquetas: {
          ...state.etiquetas,
          data: state.etiquetas.data.filter(etiqueta => etiqueta.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETA_DELETE_FILED:
      return {
        ...state,
        etiquetas: { ...state.etiquetas, loading: false, error: action.error },
      }
    case actions.ETIQUETA_SORT_ITEMS_UPDATE_REQUESTED:
      return {
        ...state,
        etiquetas: { data: mapOrder(state.etiquetas.data, action.payload, 'id'), loading: true },
      }
    case actions.ETIQUETA_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, data: null, loading: false, error: '' },
      }
    case actions.ETIQUETA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, loading: true, error: '' },
      }
    case actions.ETIQUETA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, data: action.payload, loading: false, error: '' },
      }
    case actions.ETIQUETA_BYID_LOAD_FILED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, data: null, loading: false, error: action.error },
      }
    case actions.ETIQUETA_SORT_ITEMS_UPDATE_SUCCEEDED:
      return {
        ...state,
        etiquetas: {
          data: mapOrder(state.etiquetas.data, action.payload, 'id'),
          loading: false,
        },
      }
    case actions.ETIQUETA_SORT_ITEMS_UPDATE_FILED:
      return {
        ...state,
        etiquetas: {
          ...state.etiquetas,
          loading: false,
          error: action.error,
        },
      }
    case actions.ETIQUETA_UPDATE_REQUESTED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, loading: true, error: '' },
      }
    case actions.ETIQUETA_UPDATE_SUCCEEDED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, data: action.payload, loading: false, error: '' },
      }
    case actions.ETIQUETA_UPDATE_FILED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, loading: false, error: action.error },
      }
    case actions.ETIQUETA_INSERT_REQUESTED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, loading: true, error: '' },
      }
    case actions.ETIQUETA_INSERT_SUCCEEDED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, data: action.payload, loading: false, error: '' },
      }
    case actions.ETIQUETA_INSERT_FILED:
      return {
        ...state,
        etiqueta: { ...state.etiqueta, loading: false, error: action.error },
      }

    default:
      return state
  }
}
